import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { searchSupplements } from '@api/supplements';
import { IDietarySupplementSearchResult, ISearchSupplementsProps } from '@interfaces/supplements';

import { buildSearchSupplementsPayload } from './utils';

export const handleSearchSupplements = createAsyncThunk<
  AxiosResponse<IDietarySupplementSearchResult>,
  ISearchSupplementsProps
>('searchSupplements', props => searchSupplements(buildSearchSupplementsPayload(props)));
